module.exports = __webpack_public_path__ + "img/SamsungGalaxyOn7Prime.f239e418.png";